import { Route } from '@angular/router';

import { SavedViewResolver, SavedViewsResolver } from 'app/core';
import { ProjectDataResolver, ProjectsFieldDefsResolver } from 'app/modules/projects/projects.resolvers';
import { CustomObjectsComponent } from './custom-objects.component';
import { CustomObjectsResolver } from './custom-objects.resolver';
import { CustomObjectsDashboardDetailsComponent, CustomObjectsDashboardComponent } from './dashboard';
import { CustomObjectsListComponent } from './list/list.component';
import { RelatedToType } from '@shared/enums';
import { ViewCustomObjectsGuard } from './custom-objects.guard';

export const customObjectsRoutes: Route[] = [
  {
    path: ':id',
    component: CustomObjectsComponent,
    resolve: {
      savedViews: SavedViewsResolver,
      customObject: CustomObjectsResolver,
    },
    children: [
      {
        path: ':saved_view_id/table',
        component: CustomObjectsListComponent,
        canActivate: [ViewCustomObjectsGuard],
        resolve: {
          savedViews: SavedViewsResolver,
          savedView: SavedViewResolver,
          options: ProjectDataResolver,
          fieldDefs: ProjectsFieldDefsResolver,
        },
      },
    ],
  },
  {
    path: ':customObjectId/:customObjectValueId',
    component: CustomObjectsDashboardComponent,
    data: {
      relatedToType: RelatedToType.CustomObjectValue,
    },
    resolve: {
      options: ProjectDataResolver,
      fieldDefs: ProjectsFieldDefsResolver,
      customObject: CustomObjectsResolver,
    },
    children: [
      {
        path: 'details',
        component: CustomObjectsDashboardDetailsComponent,
      },
      {
        path: 'folders',
        loadChildren: () => import('../../../shared/modules/folders/folders.module').then((m) => m.FoldersTabModule),
      },
      {
        path: 'details/:tabId',
        component: CustomObjectsDashboardDetailsComponent,
      },
      {
        path: 'notes',
        loadChildren: () => import('app/shared/modules/notes/notes.module').then((m) => m.NotesModule),
      },
      {
        path: 'tasks',
        data: { taskModuleRelatedTo: RelatedToType.CustomObject },
        loadChildren: () => import('app/shared/modules/legacy-tasks/tasks.module').then((m) => m.LegacyTasksTabModule),
      },
      {
        path: 'new-tasks',
        resolve: {
          customObject: CustomObjectsResolver,
        },
        // loadComponent: () => import('@tasks/task-shell/task-shell.component').then((module) => module.TaskShellComponent),
        loadChildren: () => import('@tasks/tasks.routes').then((m) => m.routes),
      },
      {
        path: 'link/:id',
        component: CustomObjectsComponent,
        data: {
          fromCODetails: true,
        },
        resolve: {
          savedViews: SavedViewsResolver,
          customObject: CustomObjectsResolver,
        },
        children: [
          {
            path: ':saved_view_id/table',
            component: CustomObjectsListComponent,
            resolve: {
              savedViews: SavedViewsResolver,
              savedView: SavedViewResolver,
              options: ProjectDataResolver,
              fieldDefs: ProjectsFieldDefsResolver,
            },
          },
        ],
      },
    ],
  },
];
